/**
 * Simple filter persistence utility for localStorage
 * Works with this branch's local component state architecture
 */

const STORAGE_KEY = "neuron-filters";

export interface FilterState {
  searchTerm?: string;
  selectedFeatures?: string[];
  selectedTags?: string[];
  selectedAuthors?: string[];
  selectedQueryTypes?: string[];
  selectedTables?: string[];
  selectedColumns?: string[];
  selectedIndicationEnrichments?: string[];
  selectedMedicationEnrichments?: string[];
  extractionRange?: [number, number];
  isExtractionRangeSet?: boolean;
  showUniqueQueries?: boolean;
}

export function saveFiltersToStorage(filters: FilterState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch (error) {
    console.warn("Failed to save filters to localStorage:", error);
  }
}

export function loadFiltersFromStorage(): FilterState | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.warn("Failed to load filters from localStorage:", error);
  }
  return null;
}

export function clearFiltersFromStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn("Failed to clear filters from localStorage:", error);
  }
}
